import React from 'react';
import SkinSelector from '../../propertyPanel/CommonProperties/SkinSelector';

/**
 * 게시판 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const BoardProperties = [
  {
    group: '스킨 설정',
    properties: [
      {
        name: 'skin',
        label: '외부 스킨',
        control: (props: any) => <SkinSelector {...props} />,
        defaultValue: 'basic'
      }
    ]
  },
  {
    group: '기본 설정',
    properties: [
      {
        name: 'data.title',
        label: '게시판 제목',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'data.parameter',
        label: '게시판 파라미터',
        control: 'TextField',
        defaultValue: '',
        helperText: '카테고리 ID나 게시판 구분값을 입력하세요.'
      },
      {
        name: 'data.showNewButton',
        label: '새글 버튼 표시',
        control: 'Checkbox',
        defaultValue: true,
        helperText: '게시판에 새 글 작성 버튼을 표시할지 설정합니다.'
      },
      {
        name: 'data.showDetailButtons',
        label: '상세 페이지 버튼 표시',
        control: 'Checkbox',
        defaultValue: true,
        helperText: '게시글 상세 페이지에서 수정/삭제 버튼을 표시할지 설정합니다.'
      }
    ]
  },
  {
    group: '여백 설정',
    properties: [
      {
        name: 'style.paddingTop',
        label: '위쪽 여백',
        control: 'TextField',
        defaultValue: '0px',
        helperText: '예: 10px, 1rem, 5%'
      },
      {
        name: 'style.paddingRight',
        label: '오른쪽 여백',
        control: 'TextField',
        defaultValue: '0px',
        helperText: '예: 10px, 1rem, 5%'
      },
      {
        name: 'style.paddingBottom',
        label: '아래쪽 여백',
        control: 'TextField',
        defaultValue: '0px',
        helperText: '예: 10px, 1rem, 5%'
      },
      {
        name: 'style.paddingLeft',
        label: '왼쪽 여백',
        control: 'TextField',
        defaultValue: '0px',
        helperText: '예: 10px, 1rem, 5%'
      }
    ]
  },
  {
    group: '배경 및 테두리',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: 'transparent',
        helperText: '예: #ffffff, rgb(255,255,255), transparent'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 반경',
        control: 'TextField',
        defaultValue: '0px',
        helperText: '예: 5px, 0.5rem, 50%'
      },
      {
        name: 'style.boxShadow',
        label: '그림자 효과',
        control: 'TextField',
        defaultValue: 'none',
        helperText: '예: 0px 4px 8px rgba(0,0,0,0.1), none'
      }
    ]
  },
  {
    group: '디바이스별 설정',
    properties: [
      {
        name: 'data.device.pc.title',
        label: 'PC 게시판 제목',
        control: 'TextField',
        defaultValue: '',
        helperText: 'PC 화면에서 표시될 제목입니다. 비워두면 기본 설정을 사용합니다.'
      },
      {
        name: 'data.device.pc.parameter',
        label: 'PC 게시판 파라미터',
        control: 'TextField',
        defaultValue: '',
        helperText: 'PC 화면에서 사용할 파라미터입니다. 비워두면 기본 설정을 사용합니다.'
      },
      {
        name: 'data.device.pc.showNewButton',
        label: 'PC 새글 버튼 표시',
        control: 'Checkbox',
        defaultValue: true,
        helperText: 'PC 화면에서 새 글 작성 버튼을 표시할지 설정합니다.'
      },
      {
        name: 'data.device.mobile.title',
        label: '모바일 게시판 제목',
        control: 'TextField',
        defaultValue: '',
        helperText: '모바일 화면에서 표시될 제목입니다. 비워두면 기본 설정을 사용합니다.'
      },
      {
        name: 'data.device.mobile.parameter',
        label: '모바일 게시판 파라미터',
        control: 'TextField',
        defaultValue: '',
        helperText: '모바일 화면에서 사용할 파라미터입니다. 비워두면 기본 설정을 사용합니다.'
      },
      {
        name: 'data.device.mobile.showNewButton',
        label: '모바일 새글 버튼 표시',
        control: 'Checkbox',
        defaultValue: true,
        helperText: '모바일 화면에서 새 글 작성 버튼을 표시할지 설정합니다.'
      }
    ]
  },
  {
    group: '고급 설정',
    properties: [
      {
        name: 'style.__forceUpdatePadding',
        label: '여백 설정 강제 적용',
        control: 'Checkbox',
        defaultValue: false,
        helperText: '스타일이 덮어씌워지는 경우 사용합니다.'
      }
    ]
  }
];

export default BoardProperties;